import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';

type ViewContext = {
  browserPushEventId?: string;
  fetchUrl?: string;
  [key: string]: any;
};
export const ViewContext = createContext<ViewContext | undefined>(undefined);

export const useViewContext = () => {
  const value = useContext(ViewContext) as ViewContext;
  if (value === undefined) {
    throw Error('ViewContext is used without Provider');
  }
  return value;
};

export function ViewContextProvider({
  children,
  browserPushEventId,
  fetchUrl,
  ...customProps
}: PropsWithChildren<ViewContext>) {
  const viewContext = useMemo(
    () => ({
      browserPushEventId,
      fetchUrl,
      ...customProps,
    }),
    [browserPushEventId, fetchUrl],
  );
  return <ViewContext.Provider value={viewContext}>{children}</ViewContext.Provider>;
}

export const useBrowserPushEventId = () => {
  const { browserPushEventId } = useViewContext();
  if (browserPushEventId === undefined) {
    throw Error('View does not have a browserPushEventId');
  }
  return browserPushEventId;
};

export const useFetchUrl = () => {
  const { fetchUrl } = useViewContext();
  if (fetchUrl === undefined) {
    throw Error('View does not have a browserPushEventId');
  }
  return fetchUrl;
};
